const isBeta = false; // Don't forget to also change the 'homepage' field in package.json when changing isBeta! ('/release' or '/beta')
const isLocal = false;

export { isBeta, isLocal };